import { atom } from 'nanostores';

import { api, type RequestLog, type UsageResponse } from '../lib/api';
import { isStaleSession, messageOf, onSessionCleared, sessionEpoch } from './auth';

export const $usage = atom<UsageResponse | null>(null);
export const $requests = atom<RequestLog[]>([]);
export const $usageLoading = atom(false);
export const $usageError = atom<string | null>(null);

export function resetUsage(): void {
  $usage.set(null);
  $requests.set([]);
  $usageLoading.set(false);
  $usageError.set(null);
}

onSessionCleared(resetUsage);

export async function loadUsage(days = 30): Promise<void> {
  const captured = sessionEpoch();
  $usageLoading.set(true);
  $usageError.set(null);
  try {
    // Both panels are always shown together, so fetch them together.
    const [usage, recent] = await Promise.all([api.usage(days), api.recentRequests(50)]);
    if (isStaleSession(captured)) return;
    $usage.set(usage);
    $requests.set(recent.requests);
  } catch (err) {
    $usageError.set(messageOf(err));
  } finally {
    $usageLoading.set(false);
  }
}
